import { createFileRoute, Navigate } from '@tanstack/react-router';

const Component = () => {
  const { studentId } = Route.useParams();
  return (
    <Navigate
      to={`/students/$studentId/details`}
      params={{
        studentId,
      }}
    />
  );
};
export const Route = createFileRoute('/_auth/_layout/students/$studentId/')({
  component: Component,
});
